<template>
    <ui-tooltip ref="tooltip" trigger="none" :class-extra-name="css.tooltip">
        <div @click="tooltip?.show()">
            <slot>
                <div class="default-share-control">
                    <UiIcon class="share-control-icon" name="share" />
                    <span class="share-control-context">{{ $t("Share") }}</span>
                </div>
            </slot>
        </div>
        <template #content>
            <div :class="css.main">
                <div :class="css.close" @click="tooltip?.hidden()">
                    <ui-icon name="close2" />
                </div>
                <!-- * 标题 -->
                <div :class="css.title">{{ $t("Share") }}</div>

                <!-- * 分享内容 -->
                <div :class="css.content">
                    <slot name="content"></slot>
                </div>

                <!-- * 分享途径 -->
                <div :class="[css.ways, $i18n.locale === 'zh' ? css.zh : css.en]">
                    <div :class="css.control" @click="methods.copy">
                        <img src="https://rdgta.cdn.cyagen.com/rddc/images/copy.webp" alt="Copy" />
                        <span>{{ $t("Copy", 2) }}</span>
                    </div>
                    <div :class="css.control" @click="methods.weibo">
                        <img src="https://rdgta.cdn.cyagen.com/rddc/images/weibo.webp" alt="Weibo" />
                        <span>{{ $t("Weibo") }}</span>
                    </div>
                    <div :class="css.control" @click="methods.copy">
                        <img src="https://rdgta.cdn.cyagen.com/rddc/images/wechat.webp" alt="Wechat" />
                        <span> {{ $t("Wechat") }}</span>
                    </div>
                    <div :class="css.control" @click="methods.copy">
                        <img src="https://rdgta.cdn.cyagen.com/rddc/images/bilibili.webp" alt="Bilibili" />
                        <span>Bilibili</span>
                    </div>
                </div>
            </div>
        </template>
    </ui-tooltip>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiTooltip } from "various-ui";
//* 样式
import css from "./index.module.less";
//* 组件属性
import { DefaultSharePropsOption } from "./index";
import { useComposable } from "./src/composable";

//* 组件属性注册
const define = defineProps(DefaultSharePropsOption);

const { nodes, methods } = useComposable(define);
const { tooltip } = nodes;
</script>
